var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRateReviewFill0Wght400Grad0Opsz24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 46,
    viewBox: "0 0 71 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12721",
    "data-name": "Group 12721",
    transform: "translate(7615.5 3929.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10105",
    "data-name": "Rectangle 10105",
    width: 70,
    height: 45,
    rx: 22.5,
    transform: "translate(-7615 -3929)",
    fill: "#e1e5f2",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "rate_review_FILL0_wght400_GRAD0_opsz24",
    d: "M85.5-866.8h1.788a1.138,1.138,0,0,0,.426-.083,1.1,1.1,0,0,0,.371-.247l5.17-5.17a1.631,1.631,0,0,0,.371-.564,1.691,1.691,0,0,0,.124-.619,1.361,1.361,0,0,0-.137-.591,2.28,2.28,0,0,0-.357-.536l-.99-1.045a1.667,1.667,0,0,0-.55-.371,1.654,1.654,0,0,0-.632-.124,1.691,1.691,0,0,0-.619.124,1.631,1.631,0,0,0-.564.371l-5.17,5.17a1.1,1.1,0,0,0-.247.371,1.137,1.137,0,0,0-.083.426v1.788a1.064,1.064,0,0,0,.316.784A1.064,1.064,0,0,0,85.5-866.8Zm6.6-6.682L91.083-874.5Zm-6.05,5.032v-1.045l2.777-2.777.55.495.5.55L87.1-868.45Zm3.327-3.327.5.55-1.045-1.045Zm.715,4.977H96.5a1.064,1.064,0,0,0,.784-.316,1.064,1.064,0,0,0,.316-.784,1.064,1.064,0,0,0-.316-.784A1.064,1.064,0,0,0,96.5-869H92.293ZM84.4-862.4l-2.53,2.53a1,1,0,0,1-1.2.234A1.036,1.036,0,0,1,80-860.667V-877.8a2.119,2.119,0,0,1,.646-1.554A2.119,2.119,0,0,1,82.2-880H99.8a2.119,2.119,0,0,1,1.554.646A2.119,2.119,0,0,1,102-877.8v13.2a2.118,2.118,0,0,1-.646,1.554,2.118,2.118,0,0,1-1.554.646Zm-.935-2.2H99.8v-13.2H82.2v14.438Zm-1.265,0v0Z",
    transform: "translate(-7670.814 -3037)",
    fill: "#161616"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRateReviewFill0Wght400Grad0Opsz24);
export default __webpack_public_path__ + "static/media/rate_review_FILL0_wght400_GRAD0_opsz24.d00a36546293bbb1c210d6402dc8e7ea.svg";
export { ForwardRef as ReactComponent };